import React from "react";
import { useSubscription } from "@apollo/client";
import { PROPERTY_CONTRACT_UPDATED_SUBSCRIPTION } from "data/graphql/property-contract-updated-subscription";

/**
 * Subscribes when `propertyContractUpdated` matches `contractId` (org-scoped on server).
 * Returns true once the contract reaches `signed` (step 7 download UX).
 */
export const usePropertyContractUpdatedSocket = (
  _orgId: string | null | undefined,
  contractId: string | null | undefined,
  enabled: boolean,
): boolean => {
  const [signedFromSubscription, setSignedFromSubscription] = React.useState(false);

  const { data: subscriptionData } = useSubscription(PROPERTY_CONTRACT_UPDATED_SUBSCRIPTION, {
    skip: !enabled || !contractId,
  });

  React.useEffect(() => {
    setSignedFromSubscription(false);
  }, [contractId]);

  React.useEffect(() => {
    if (!contractId) {
      return;
    }
    const c = subscriptionData?.propertyContractUpdated;
    if (c && c.id === contractId && c.status === "signed") {
      setSignedFromSubscription(true);
    }
  }, [subscriptionData, contractId]);

  return signedFromSubscription;
};
